import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ModuloSelecionadoService {
  private moduloSelecionadoSubject = new BehaviorSubject<number | null>(null);

  moduloSelecionado$ = this.moduloSelecionadoSubject.asObservable();

  setModuloSelecionado(id: number) {
    this.moduloSelecionadoSubject.next(id);
  }
  getModuloSelecionado() {
    return this.moduloSelecionadoSubject.value;
  }
}
